<template lang="html">
  <div class="form-check mpv-checkbox">
    <input
      @change="$emit('checkChanged')"
      type="checkbox"
      :disabled="checkDisabled"
      class="form-check-input fix-pos"
      :checked="isChecked">
    <span class="checkmark fix-pos"><span></span></span>
    <label for="" class="form-check-label"></label>
  </div>
</template>

<script>
export default {
  props: {
    isChecked: Boolean,
    checkDisabled: Boolean
  }
}
</script>

<style lang="scss">
  .mpv-checkbox {
    .checkmark.fix-pos {
      top: unset;
      bottom: unset;
      left: unset;
      right: 0;
    }

    input.fix-pos {
      right: 0;
      width: 1rem;
    }

    input:disabled {
      cursor: default;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ui/forms/InlineCheck.vue